import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetSingleClass = async (ClassID) => {
  try {
    const ClassesCollection = collection(db, "Classes");
    const ClassDocument = doc(ClassesCollection, ClassID);
    const ClassSnapshot = await getDoc(
      ClassDocument,
      where("IsDeleted", "==", false)
    );

    let Class = { ...ClassSnapshot.data(), id: ClassSnapshot.id };

    return Class;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleClass;
